import React, { useEffect, useState } from 'react';
import MeetingParticipantItem from './MeetingParticipantItem';
import VirtualList from '../../../chat/components/web/VirtualList';
/**
 * Component used to display a list of meeting participants.
 *
 * @returns {ReactNode}
 */
function MeetingParticipantItems({ isInBreakoutRoom, lowerMenu, toggleMenu, muteAudio, participantIds, openDrawerForParticipant, overflowDrawer, raiseContextId, participantActionEllipsisLabel, searchString, stopVideo, youText, isRaisedHand, renderAll = false, leftParentElRef, percentDisplayVirtualList = 30, handleClick }) {
    const renderParticipant = (id) => {
        return (React.createElement(MeetingParticipantItem, { isHighlighted: raiseContextId === id, isInBreakoutRoom: isInBreakoutRoom, key: id, muteAudio: muteAudio, onContextMenu: toggleMenu(id), onLeave: lowerMenu, openDrawerForParticipant: openDrawerForParticipant, overflowDrawer: overflowDrawer, participantActionEllipsisLabel: participantActionEllipsisLabel, participantID: id, searchString: searchString, stopVideo: stopVideo, youText: youText, isRaisedHand: isRaisedHand, renderAll: renderAll, handleClick: handleClick }));
    };
    const [heightVirtual, setHeightVirtual] = useState(leftParentElRef?.current?.getBoundingClientRect()?.height || 1);
    useEffect(() => {
        if (participantIds?.length < 4) {
            setHeightVirtual(participantIds.length * 48);
        }
        else {
            setHeightVirtual((leftParentElRef?.current?.getBoundingClientRect()?.height || 1) * percentDisplayVirtualList / 100);
        }
    }, [participantIds.length]);
    return (React.createElement(React.Fragment, null,
        React.createElement(VirtualList, { items: participantIds, height: heightVirtual, estimatedItemHeight: 48, renderItem: (item, index) => renderParticipant(item) })));
}
// Memoize the component in order to avoid rerender on drawer open/close.
export default React.memo(MeetingParticipantItems);
